import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { AuthService } from "../../domain/auth/application/auth.service";
import { UserStore } from "../store/user.store";

export function guestGuard() {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const authService = inject(AuthService);

  if (userStore.user()) {
    return router.createUrlTree(["/dashboard"]);
  }

  return authService.getSession().pipe(
    map((session) => {
      if (!session) return true;

      userStore.setUser(session.user);
      return router.createUrlTree(["/dashboard"]);
    }),
    catchError(() => of(true))
  );
}
